import React from 'react'

interface Props {
    className?: string
    children: React.ReactNode
}

const Typography: React.FC<Props> = ({ className, children }) => {
    return <p className={`${className}`}>{children}</p>
}

Typography.defaultProps = {
    className: 'text-sm'
}

export default Typography
